import { ReactElement, ReactNode } from "react";
import { twMerge } from "tailwind-merge";
import { ProfilePicture } from "../../../components";
import { OrderInfoCardPriceInfo } from "./OrderInfoCardPriceInfo";

export const OrderInfoCard = ({
  total,
  businessName,
  className,
  children,
  logoUrl,
  isNewCustomer,
  onBusinessNameClicked,
}: {
  total: number;
  logoUrl: string | null;
  businessName: string;
  isNewCustomer: boolean;
  className?: string;
  children: ReactNode;
  onBusinessNameClicked?: () => void;
}): ReactElement => {
  return (
    <div
      className={twMerge("col-span-6 flex flex-col items-center", className)}
    >
      <div
        className={twMerge(
          "flex flex-col items-center justify-center gap-1 lg:m-auto",
        )}
      >
        <ProfilePicture
          name={businessName}
          logoUrl={logoUrl}
          size={"large"}
          className={"m-auto"}
        />
        {isNewCustomer && (
          <div
            className={
              "-mt-4 ml-8 inline-flex items-center rounded-sm bg-black p-0.5 font-semibold"
            }
          >
            <p className={"text-xs text-white"}>NEW</p>
          </div>
        )}
        <OrderInfoCardPriceInfo
          businessName={businessName}
          total={total}
          onBusinessNameClicked={onBusinessNameClicked}
        />
        {children}
      </div>
    </div>
  );
};
